export default {
  common: {
    backToHome: 'بازگشت به خانه',
    back: 'بازگشت',
    pageNotFound: 'صفحه پیدا نشد',
    pageForbidden: 'دسترسی غیرمجاز',
    edit: 'ویرایش',
    actions: 'عملیات',
    active: 'فعال',
    inactive: 'غیرفعال',
    save: 'ذخیره',
    cancel: 'انصراف',
  },
  tip: {
    pageNotFound: 'صفحه مورد نظر شما وجود ندارد یا منتقل شده است.',
    pageForbidden: 'شما اجازه دسترسی به این صفحه را ندارید.'
  },
  sidebar: {
    command: {
      search: 'جستجو…',
    },
  },
}
